import { CommonSelectInput } from 'components/common/form/select';
import { HITTER_SIDES, HitterSide } from 'lib_ts/enums/hitters.enums';
import { clone } from 'lodash';
import useHittersStore from 'stores/use-hitters-store';

export const SelectHitterSide = () => {
  const filters = useHittersStore((s) => s.filters);
  const loading = useHittersStore((s) => s.loading);

  return (
    <CommonSelectInput
      id="hitters-side"
      name="side"
      placeholder="hitters.hitter-side"
      options={HITTER_SIDES}
      value={filters.side}
      onChange={(v) =>
        useHittersStore.setState((prev) => {
          const nextFilters = clone(prev.filters);

          if (!v) {
            delete nextFilters.side;
          } else {
            nextFilters.side = v as HitterSide;
          }

          return {
            filters: nextFilters,
          };
        })
      }
      disabled={loading}
      optional
    />
  );
};
